export default "__VITE_ASSET__DPNTGUP4__"